export enum EnumNivelDesglose {
  Diario = 1,
  Horario,
  CuartoHorario,
  DiarioPeriodo,
  Mensual,
  PeriodoTemporal,
  PeridoTemporalTarifario
}
